// Format currency with decimal places, only when needed. E.g.:
// 4.00 -> £4
// 4.5 -> £4.50
// 4.25 -> £4.25
export const formatCurrencyMinimalDecimals = (number = 0, locale = 'en-GB', currencyCode = 'gbp') =>
  number.toLocaleString(locale, {
    style: 'currency',
    currency: currencyCode.toUpperCase(),
    minimumFractionDigits: Number.isInteger(number) ? 0 : 2,
    useGrouping: true,
  });
